import { create, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';

import { SlidingPane } from '@holmescorp/base-widgets/sliding-pane';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { subscribe } from 'pub-sub';
import { createNlsMiddleware, registry } from 'lcc-state';
import { delay } from '@holmescorp/common';
import { viewport } from '../support/viewport';

interface SearchPaneIcache {
	open: boolean;
	aboutToChange: boolean;
}

export interface SearchPaneProperties {
	openaction: string;
	onClose?: () => void;
}

const icache = createICacheMiddleware<SearchPaneIcache>();
const nls = createNlsMiddleware('settings');
const factory = create({
	icache,
	nls
}).properties<SearchPaneProperties>();

export const SearchPane = factory(({ properties, middleware: { icache, nls } }) => {
	const { openaction, onClose } = properties();
	icache.getOrSet('aboutToChange', false);
	const open = icache.getOrSet('open', () => {
		subscribe(openaction, async () => {
			icache.set('aboutToChange', true);
			await delay(200);
			icache.set('open', true);
		});
		subscribe('close-all/panes', () => {
			icache.set('open', false);
		});
		return false;
	});

	const { vw } = viewport();

	const {
		messages: { search_title = '[settings] search_title' }
	} = nls();
	const xqa = `search-pane-${open}`;

	return w(
		SlidingPane,
		{
			xqa,
			key: 'search-pane',
			open,
			align: 'right',
			underlay: true,
			title: search_title,
			width: Math.min(vw, 1024),
			onRequestClose: () => {
				icache.set('open', false);
				icache.set('aboutToChange', async () => {
					await delay(500);
					return true;
				});
				onClose && onClose();
			}
		},
		[w('Search', {})]
	);
});

registry.define('SearchPane', SearchPane);
